import React from 'react';
import { Instagram } from 'lucide-react';
import Card,{
    CardContent,
    CardHeader,
    CardTitle,
  } from '../shared/Card';

const baterias = [
  {
    name: 'SaSamba (Adelaide)',
    instagram: '@sasambaband',
    status: 'confirmed'
  },
  {
    name: 'Sambatuka (Adelaide)',
    instagram: '@sambatuka_adelaide',
    status: 'confirmed'
  },
  {
    name: 'Bloco3K (Melbourne)',
    instagram: '@bloco3k',
    status: 'confirmed'
  },
  {
    name: 'Oziriguidum (Melbourne)',
    instagram: '@oziriguidum.samba',
    status: 'confirmed'
  },
  {
    name: 'Raio de Sol (Canberra)',
    instagram: '@raio.de.sol.band',
    status: 'confirmed'
  },
  {
    name: 'Bateria 61 (Sydney)',
    instagram: '@bateria61',
    status: 'confirmed'
  },
  {
    name: 'SambaFrog (Newcastle)',
    instagram: '@sambafrog',
    status: 'confirmed'
  },
  {
    name: 'Bay Batucada (Hawke\'s Bay - NZ)',
    instagram: '@bay.batucada',
    status: 'confirmed'
  },
  {
    name: 'Unidos da Cacatua (AU - NZ)',
    instagram: '@unidosdacacatua',
    status: 'confirmed'
  }
];

const FeaturedBaterias = () => {
    const getInstagramUrl = (handle) => {
      const cleanHandle = handle.replace('@', '').toLowerCase();
      return `https://www.instagram.com/${cleanHandle}`;
    };
  
    return (
      <section id="featured-baterias" className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">        
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {baterias.map((bateria) => (
              <Card 
                key={bateria.name} 
                hover={true}
                className="overflow-hidden"
              >
                <CardHeader>
                  <CardTitle>
                    {bateria.name}
                  </CardTitle>
                </CardHeader>
                
                <CardContent>
                  <div className="relative">
                    <a 
                      href={getInstagramUrl(bateria.instagram)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 mb-4 text-[#2E0854] font-medium hover:text-[#FF4500] border-b-2 border-[#FFE135] hover:border-[#FF4500] transition-all duration-200 group"
                    >
                      <Instagram size={20} className="text-[#2E0854] group-hover:scale-110 transition-transform duration-200 flex-shrink-0" />
                      <div className="relative w-full overflow-hidden">
                        <div className="relative w-full overflow-hidden">
                          <span className="block truncate">{bateria.instagram}</span>
                          <div className="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-white to-transparent"></div>
                        </div>
                      </div>
                    </a>
                  </div>
                  
                  <div className="flex items-center">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                      bateria.status === 'confirmed' 
                        ? 'bg-green-100 text-green-800'
                        : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {bateria.status.charAt(0).toUpperCase() + bateria.status.slice(1)}
                    </span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    );
  };
  
  export default FeaturedBaterias;